import React from 'react';
import styled from 'astroturf/react';

import DownloadIcon from 'js/design_system/icons/arrow_downward.svg';
import BookmarkIcon from 'js/design_system/icons/bookmark_outline.svg';
import BookmarkedIcon from 'js/design_system/icons/bookmark.svg';
import { Button } from 'js/design_system/Button';
import { Props as ImpressionProps } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionWatcher } from 'js/utils/impressions';
import _ButtonRow from "ReaderButtonRow-ButtonRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Reader/ReaderButtonRow.tsx?styleId=ButtonRow";


const ButtonRow = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonRow",
  styles: _ButtonRow
});

type Props = {
  impressionProps?: ImpressionProps;
  onDownload?: () => void;
  bookmarked: boolean;
  onBookmark: () => void;
  onUnbookmark: () => void;
  source?: string;
};

const ReaderButtonRow = ({
  impressionProps,
  onDownload,
  bookmarked,
  onBookmark,
  onUnbookmark,
  source,
}: Props) => (
  <ButtonRow>
    <ImpressionWatcher {...impressionProps} source={`${source}_download`}>
      {bookmarked ? (
        <Button icon={<BookmarkedIcon />} onClick={onUnbookmark}>
          Saved to library
        </Button>
      ) : (
        <Button icon={<BookmarkIcon />} onClick={onBookmark}>
          Save to library
        </Button>
      )}
    </ImpressionWatcher>
    <ImpressionWatcher {...impressionProps} source={`${source}_download`}>
      <Button icon={<DownloadIcon />} secondary onClick={onDownload}>
        Download
      </Button>
    </ImpressionWatcher>
  </ButtonRow>
);

export default ReaderButtonRow;
